<template>
  <div>
      免责声明：<br>

1.本站所有内容及测试，人工测算等并非严谨的科学研究成果，仅用于传统文化研究，学术探讨，而非宣传其实际效用。<br>
2.本站所有免费测试内容及文章皆为娱乐测试，用户不得以此作为现实参考凭证。<br>
3.本站咨询师人工测算所有内容为依照传统周易学术角度分析出发，并无科学依据，用户不得以此作为现实参考凭证，仅作为娱乐及情绪价值提供咨询服务。
  </div>
</template>
<script>
import { List } from "vant";

export default {
  components: {
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
      type:''
    };
  },
  methods: {
    onLoad() {
      this.getList();
      this.page++;
    },
    getList() {
      this.api.systemMessage({ page: this.page ,type:this.type}).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
  created () {
    this.type = this.$route.query.type
  }
};
</script>
<style lang="scss" scoped>
  .list-item {
    margin: 0 0.5rem;
    padding: 0.5rem 0;
    // height: 1.3rem;
    display: flex;
    // align-items: center;
    border-bottom: 1px solid #f0f0f0;
    .list-item-title {
      font-size: 0.3rem;
      font-weight: 400;
      color: #666666;
    }
    .list-item-time {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
    }
    .list-item-state {
      flex: 1;
      text-align: right;

      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-right: 0.58rem;
    }
    .list-item-more {
      .num {
        font-size: 0.3rem;
        font-weight: 400;
        color: #ffa380;
        margin-right: 0.12rem;
      }
      i {
        font-size: 12px;
        color: #cccccc;
      }
    }
  }
</style>
